import * as Preact from "preact"
import "@fae/source/views/components/EncounterArea.less"
import Dev from "@fae/source/models/dev/Dev.js"

export default class EncounterArea {
    render() {
        const encounter = this.props.encounter
        const minX = Math.min(...encounter.points.map((point) => point.x))
        const maxX = Math.max(...encounter.points.map((point) => point.x))
        const minY = Math.min(...encounter.points.map((point) => point.y))
        const maxY = Math.max(...encounter.points.map((point) => point.y))

        let polygon = []
        if(encounter.points != undefined) {
            polygon = [
                ...encounter.points,
                encounter.points[0]
            ]
            polygon = polygon.map((point) => {
                return {
                    "x": point.x - minX,
                    "y": point.y - minY,
                }
            })
        } else {
            const x1 = 0
            const y1 = 0
            const x2 = 0 + encounter.width
            const y2 = 0 + encounter.height
            polygon = [
                {"x": x1, "y": y1},
                {"x": x2, "y": y1},
                {"x": x2, "y": y2},
                {"x": x1, "y": y2},
                {"x": x1, "y": y1},
            ]
        }
        const polygonStrings = polygon.map((point) => {
            return point.x + "em" + " " + point.y + "em"
        })

        return (
            <div
                class="EncounterArea"
                isHovered={this.isHovered + ""}
                style={{
                    "width": maxX - minX + "em",
                    "height": maxY - minY + "em",
                    "left": minX + "em",
                    "top": minY + "em",
                    "clip-path": "polygon(" + polygonStrings.join(", ") + ")",
                }}
            />
        )
    }
    get isHovered() {
        return this.props.encounter.key == Dev.devSelection.hoveredEncounterKey
            || this.props.encounter.key == Dev.devSelection.listHoveredEncounterKey
    }
}
